import Apis from "@/api/index";
import AES from "@/utils/aes";
import OSS from "ali-oss";
import reg from "./reg";

const OSSConfig = {}

function random_string(len) {
	len = len || 32
	var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
	var maxPos = chars.length
	var pwd = ''
	for (let i = 0; i < len; i++) {
		pwd += chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return pwd
}

/**
 *
 * @param event 上传图片的资源路径
 * @param type 图片资源类型
 * @param dir oss要保存的文件夹
 * @returns {OSS文件路径}
 */

function uploadOSS(file) {
	return new Promise(async (resolve, reject) => {
		try {
			// 从接口获取OSS配置
			const res = await Apis.getOssInfo();
			// 解密接口返回的数据
			const ossConfig = JSON.parse(AES.decrypt(res.data));
			// 创建OSS客户端
			var client = new OSS({
				region: 'oss-cn-hangzhou',
				accessKeyId: ossConfig.accessKeyId,
				accessKeySecret: ossConfig.accessKeySecret,
				secure: true,
				bucket: ossConfig.ossBucketName,
			});
			// 获取文件类型
			let fileName = reg.getFileType(file.name)
			// 生成上传路径
			const aliyunFileKey = 'LVJU/image' + '/' + new Date().getTime() + Math.floor(Math.random() * 150) + '.' + fileName;
			// 执行上传
			var result = await client.multipartUpload(aliyunFileKey, file);
			// 生成URL
			var url = (ossConfig.ossHost || OSSConfig.ossHost) + '/' + result.name;
			// 返回结果
			resolve(url);
		} catch (error) {
			console.error('OSS上传失败:', error);
			reject(error);
		}
	});
}

export { uploadOSS };

